const splitName = (name: string) => name.split(' ', 1).join();

export default splitName;



// WEBPACK FOOTER //
// ./src/services/financigservice/utils/splitName.ts